module.exports = __webpack_public_path__ + "img/logo.84492430.png";